// Manter sincronizado com BE em
// exclusivo/modules/mod_produtos/controller/previsao_numerica_tempo.py
// (HEATMAP_MODELS e HEATMAP_VARIABLES).
//
// Os valores aqui correspondem ao `modelo_value` retornado pelo endpoint
// /produtos/meteorologia/painel-options (lowercase, do banco). O backend
// converte para UPPERCASE ao montar o path do filesystem (ex: 'ampere' ->
// /home/ubuntu/resources/.../AMPERE/.../heatmap_AMPERE_cities_..._YYYYMMDD.png).
//
// Nota sobre ECMWF: usamos 'ecmwf15' (label "ECMWF" no painel) porque eh o
// unico que possui as 3 variaveis de temperatura no painel-options. O modelo
// 'ecmwf' (label "ECMWF-HRES") so tem precipitacao.
export const HEATMAP_MODELS = [
  'ampere',
  'ecmwf15',
  'gfs',
  'prevconsenso',
  'indicacaomet',
] as const;

export type HeatmapModel = typeof HEATMAP_MODELS[number];

export const isHeatmapModel = (value: string): value is HeatmapModel => (
  (HEATMAP_MODELS as readonly string[]).includes(value)
);

// Variáveis suportadas pelo Heatmap (apenas temperaturas).
// Sincronizado com BE: HEATMAP_VARIABLES = {'tmax2m', 'tmed2m', 'tmin2m'}.
export const HEATMAP_VARIABLES = [
  'tmax2m',
  'tmed2m',
  'tmin2m',
] as const;

export type HeatmapVariable = typeof HEATMAP_VARIABLES[number];

export const isHeatmapVariable = (value: string): value is HeatmapVariable => (
  (HEATMAP_VARIABLES as readonly string[]).includes(value)
);
